import { CommonResponse, RmBudgetRequest, RmBudgetResponseModel, SaleBudgetRequest, SaleBudgetResponseModel } from "@gtpl/shared-models/masters";
import axios from "axios";
import { connection } from "./connection";

export class SaleBudgetService{
    URL = connection.DEPLOY_URL + '/saleBudget';
    async createSaleBudget(req:SaleBudgetRequest): Promise<SaleBudgetResponseModel> {
        return await axios.post(this.URL + '/createSaleBudget',req)
            .then(res => {
                return res.data
            })
    }

    async getAllSaleBudget(): Promise<CommonResponse> {
        return await axios.post(this.URL + "/getAllSaleBudget")
        .then(res => {
            return res.data
          })
    }

    async getBudgetVarianceReport(month?: number, year?: number): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getBudgetVarianceReport', { month, year })
          .then(res => {
            return res.data;
          });
      }
}